exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".InfoVcDemo .demo-btn[data-v-59669bdb]{margin:10px 15px 10px}.InfoVcDemo a[data-v-59669bdb]{color:#00b386;cursor:pointer}", ""]);

// exports
